import React, { Component } from 'react'
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import { Grid } from "react-bootstrap";
import './styles.css';

export class FullPageLoader extends Component {
  render() {
    return (
      <div class='loader-container'>
        <div className="loader">
        <Grid fluid>
        <div className="text-center">
          <LoadingSpinner title='Dashboard' />
        </div>
      </Grid> 
        </div>
      </div>
    )
  }
}

export default FullPageLoader;